import apiClient from './apiClient'

export const getShippingPublicConfig = async () => {
  const { data } = await apiClient.get('/shipping/config/public/')
  return data
}

export const getShippingAdminConfig = async () => {
  const { data } = await apiClient.get('/shipping/config/')
  return data
}

export const updateShippingAdminConfig = async (payload) => {
  const { data } = await apiClient.put('/shipping/config/', payload)
  return data
}

export const quoteIngresoShipping = async ({ postal_code, items }) => {
  const { data } = await apiClient.post('/shipping/rates/ingreso/', {
    postal_code,
    items,
  })
  return data
}

/** Cotización persistida (ShippingQuote) — wholesale o ingreso */
export const createShippingQuote = async ({ source, postal_code, items }) => {
  const { data } = await apiClient.post('/shipping/quotes/', {
    source,
    postal_code,
    items,
  })
  return data
}

export const getShippingQuote = async (quoteId) => {
  const { data } = await apiClient.get(`/shipping/quotes/${quoteId}/`)
  return data
}

export const selectShippingQuoteRate = async (quoteId, selectedRate) => {
  const { data } = await apiClient.patch(`/shipping/quotes/${quoteId}/select/`, {
    selected_rate: selectedRate,
  })
  return data
}

export const getShippingAgencies = async ({ postalCode = '', provinceCode = '' } = {}) => {
  const { data } = await apiClient.get('/shipping/agencies/', {
    params: {
      ...(postalCode ? { postal_code: postalCode } : {}),
      ...(provinceCode ? { province_code: provinceCode } : {}),
    },
  })
  return data
}

export const listShipments = async (params = {}) => {
  const { data } = await apiClient.get('/shipping/shipments/', { params })
  return data
}

export const importShipmentToCorreo = async (shipmentId) => {
  const { data } = await apiClient.post(`/shipping/shipments/${shipmentId}/import/`)
  return data
}

export const syncPendingShipments = async () => {
  const { data } = await apiClient.post('/shipping/sync-pending/')
  return data
}

export const getShippingModalidad = async () => {
  const { data } = await apiClient.get('/shipping/modalidad/')
  return data
}

/** Chequear tracking de los envíos importados (admin): actualiza estado y código de seguimiento */
export const syncShipmentTracking = async (shipmentIds = []) => {
  const { data } = await apiClient.post('/shipping/sync-tracking/', {
    shipment_ids: shipmentIds,
  })
  return data
}

/** Enviar al cliente el email con el código de seguimiento (admin) */
export const notifyShipmentTracking = async (shipmentId) => {
  const { data } = await apiClient.post(`/shipping/shipments/${shipmentId}/notify-tracking/`)
  return data
}

export const updateShipment = async (shipmentId, payload) => {
  const { data } = await apiClient.patch(`/shipping/shipments/${shipmentId}/update/`, payload)
  return data
}

/** Obtiene y sincroniza el tracking de un envío puntual. */
export const getShipmentTracking = async (shipmentId) => {
  const { data } = await apiClient.get(`/shipping/shipments/${shipmentId}/tracking/`)
  return data
}
